module.exports = __webpack_public_path__ + "static/media/member-introduction-piotr-chojnacki.034b86d0.jpg";